const getters = {
  user: (state) => state.common.user,
  moduleList: (state) => state.common.user.moduleList,
  bmxmList: (state) => state.common.bmxmList,
  xmcbhsParams: (state) => state.xmcbhs.xmcbhsParams,
  cgw: (state) => state.cgw,
  deptUser: state => state.common.deptUser,
  task: (state) => state.task,
  question: (state) => state.question,
  course: (state) => state.course,
  xgpg: (state) => state.xgpg,
  zxlc: (state) => state.zxlc,
  common: (state) => state.common,
};
export default getters;
